import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import AdminPage from "@/pages/AdminPage";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import QuickFacts from "@/components/QuickFacts";
import MarqueeBand from "@/components/MarqueeBand";
import Story from "@/components/Story";
import Batches from "@/components/Batches";
import Itinerary from "@/components/Itinerary";
import ParallaxBreak from "@/components/ParallaxBreak";
import Inclusions from "@/components/Inclusions";
import Reviews from "@/components/Reviews";
import FAQ from "@/components/FAQ";
import LeadForm from "@/components/LeadForm";
import Footer from "@/components/Footer";
import StickyCTA from "@/components/StickyCTA";
import InquiryModal from "@/components/InquiryModal";
import WhatsAppFloat from "@/components/WhatsAppFloat";

const NOISE_URI =
  "data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E";

function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-background text-foreground font-body overflow-x-clip">
      <div
        aria-hidden="true"
        className="pointer-events-none fixed inset-0 z-[70] opacity-[0.05]"
        style={{ backgroundImage: `url("${NOISE_URI}")` }}
      />
      <div
        className="fixed top-0 left-0 right-0 z-50 h-8 bg-[#178A32] text-[#F5F2EB] flex items-center justify-center px-4"
        data-testid="announcement-bar"
      >
        <p className="text-[10px] md:text-[11px] uppercase tracking-[0.2em] font-semibold text-center">
          Travel now, pay later — flexible no-cost EMI options
        </p>
      </div>
      <Header />
      <main>
        <Hero />
        <QuickFacts />
        <MarqueeBand />
        <Story />
        <Batches />
        <Itinerary />
        <ParallaxBreak />
        <Inclusions />
        <Reviews />
        <FAQ />
        <LeadForm />
      </main>
      <Footer />
      <StickyCTA />
      <InquiryModal />
      <WhatsAppFloat />
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#1A362B",
            color: "#F5F2EB",
            border: "1px solid #A6422D",
            borderRadius: "2px",
            fontFamily: "'Manrope', sans-serif",
          },
        }}
      />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/:slug" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}
